const en = require('./en');
const es = require('./es');

module.exports = {
  en,
  es,
};
